import { render, staticRenderFns } from "./Edit-Share-File-Rights.vue?vue&type=template&id=337ac7fc&scoped=true&"
import script from "./Edit-Share-File-Rights.vue?vue&type=script&lang=js&"
export * from "./Edit-Share-File-Rights.vue?vue&type=script&lang=js&"
import style0 from "./Edit-Share-File-Rights.vue?vue&type=style&index=0&id=337ac7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ac7fc",
  null
  
)

export default component.exports